// Authentication utility functions

export const isAuthenticated = (): boolean => {
  const token = localStorage.getItem('token');
  return !!token;
};

export const getToken = (): string | null => {
  return localStorage.getItem('token');
};

export const logout = (): void => {
  localStorage.removeItem('token');
  window.dispatchEvent(new CustomEvent('authChange', { detail: { isAuthenticated: false } }));
};

export const isTokenExpired = (token: string): boolean => {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    if (!payload.exp) return true;
    // Treat as expired if within 30 seconds of expiry
    return payload.exp * 1000 <= Date.now() + 30000;
  } catch {
    return true;
  }
};

export const validateToken = async (): Promise<boolean> => {
  const token = getToken();
  if (!token || isTokenExpired(token)) {
    if (token) logout();
    return false;
  }

  try {
    const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5001';
    const response = await fetch(`${API_URL}/api/auth/verify`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (!response.ok) {
      logout();
      return false;
    }

    return true;
  } catch {
    return false;
  }
};

export const requireAuth = async (): Promise<boolean> => {
  const isValid = await validateToken();
  if (!isAuthenticated() || !isValid) {
    logout();
    return false;
  }
  return true;
}; 